<div class="col-xl payroll-receipts-wrap">
    <div class="mb-3">
        <div class="employee-breadcrumb" *ngIf="fromPeriods">
            <a [routerLink]="['/payroll-periods']">Administrador de periodos</a> /
            <span class="current">Recibos electrónicos</span>
        </div>
        <h4 class="mb-0 receipts-title" *ngIf="!fromPeriods">Recibos electrónicos</h4>
    </div>

    <div class="row g-3 mb-4 payroll-kpi-row">
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ccf0ff;"><img src="assets/img/icons/payroll-kpi-file-text.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total recibos</p>
                    <p class="payroll-kpi-value">{{stats.total}}</p>
                    <p class="payroll-kpi-sublabel">En el período</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#e3fbe8;"><img src="assets/img/icons/payroll-kpi-check-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Timbrados</p>
                    <p class="payroll-kpi-value">{{stats.stamped}}</p>
                    <p class="payroll-kpi-sublabel">{{stampedPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#fef3d4;"><img src="assets/img/icons/payroll-kpi-clock.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Pendientes</p>
                    <p class="payroll-kpi-value">{{stats.pending}}</p>
                    <p class="payroll-kpi-sublabel">{{pendingPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ffccce;"><img src="assets/img/icons/payroll-kpi-alert-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Con error</p>
                    <p class="payroll-kpi-value">{{stats.error}}</p>
                    <p class="payroll-kpi-sublabel">{{errorPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card payroll-kpi-card-net">
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Neto a pagar del período</p>
                    <p class="payroll-kpi-value">{{formatCurrency(stats.net_period_total)}}</p>
                    <p class="payroll-kpi-sublabel">{{stats.total}} recibos</p>
                </div>
            </div>
        </div>
    </div>

    <div class="payroll-tabs mb-0">
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'all'" (click)="setTab('all')">
            Todos <span class="payroll-tab-badge" style="background:#ccf0ff;color:#006d99;">{{stats.total}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'pending'" (click)="setTab('pending')">
            Pendientes <span class="payroll-tab-badge" style="background:#fef3d4;color:#cf8515;">{{stats.pending}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'stamped'" (click)="setTab('stamped')">
            Timbrado <span class="payroll-tab-badge" style="background:#e3fbe8;color:#3c7e43;">{{stats.stamped}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'error'" (click)="setTab('error')">
            Error <span class="payroll-tab-badge" style="background:#ffccce;color:#c5010b;">{{stats.error}}</span>
        </button>
    </div>

    <div class="payroll-panel">
        <div class="d-flex flex-wrap align-items-end gap-3 mb-3">
            <div class="receipts-filter-group">
                <label class="receipts-filter-label">Nombre y apellido</label>
                <div class="receipts-filter-input">
                    <input type="text" placeholder="Buscar" [(ngModel)]="filterSearch" (ngModelChange)="onSearchChanged()">
                </div>
            </div>
            <div class="receipts-filter-group">
                <label class="receipts-filter-label">Estado CFDI</label>
                <div class="receipts-filter-input">
                    <select [(ngModel)]="activeTab" (ngModelChange)="fetchReceipts()">
                        <option value="all">Seleccionar</option>
                        <option value="pending">Pendiente</option>
                        <option value="stamped">Timbrado</option>
                        <option value="error">Error</option>
                    </select>
                </div>
            </div>
            <div class="receipts-filter-group">
                <label class="receipts-filter-label">Periodo de pago</label>
                <div class="receipts-filter-input">
                    <input type="date" #periodInput [(ngModel)]="filterPeriod" (ngModelChange)="onFilterChanged()">
                    <img src="assets/img/icons/icon-calendar-field.svg" alt="" class="receipts-filter-icon" (click)="periodInput.showPicker()">
                </div>
            </div>
            <button type="button" class="receipts-stamp-massive-btn" *ngIf="canDo('Timbrar')" (click)="openStampWizard()">
                <img src="assets/img/icons/icon-qr-code.svg" alt=""> Timbrado masivo
            </button>
        </div>

        <div class="payroll-grid ag-theme-alpine" style="height: 50vh; width: 100%;" *ngIf="!loadError">
            <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true" [context]="gridContext"
                [overlayNoRowsTemplate]="noRowsTemplate" (gridReady)="onGridReady($event)"
                (cellClicked)="onCellClicked($event)">
            </ag-grid-angular>
        </div>

        <div class="payroll-empty-state" *ngIf="loadError">
            <i class="ti ti-file-x"></i>
            <p class="mb-0">No se pudo cargar el listado de recibos de nómina.</p>
        </div>
    </div>

    <div class="receipts-period-banner mt-3" *ngIf="fromPeriods">
        <i class="ti ti-info-circle"></i>
        Mostrando periodo {{formatDate(filterPeriod)}}
        <button type="button" class="receipts-period-banner-btn" (click)="volverAlAdminDePeriodos()">
            <i class="ti ti-corner-up-left"></i>&nbsp;Volver al Admin. de periodos
        </button>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>

<app-stamp-wizard-modal #stampWizard (completed)="fetchReceipts()"></app-stamp-wizard-modal>
